import * as React from 'react';
import { connect } from 'react-redux';

import { renderErrorObject } from '../../common/Render';

import { pm as PmAction } from '../../../../actions'

import LoadingCircle from '../../../loading/Circle';

import RemoteQuery from '../../RemoteQuery';
import RemoteDataUtil from '../../util/RemoteDataUtil';

import Widget from './Widget';
import ISettings from './ISettings';
import { IReportSettings } from '../../../../interfaces';
import IState from '../../../../interfaces/states';

interface IWidgetData {
    systems
}

interface IProps {
    widgetId: string,
    widgetData: IWidgetData,
    listSystems: Function,
    requestOptions: Object,
    settings: ISettings,
    reportSettings: IReportSettings,
}

class WidgetContainer extends React.Component<IProps, void> {
    static propTypes = {
        widgetId: React.PropTypes.string.isRequired,
        widgetData: React.PropTypes.object.isRequired,
        listSystems: React.PropTypes.func.isRequired,
        requestOptions: React.PropTypes.object,
        settings: React.PropTypes.object.isRequired,
        reportSettings: React.PropTypes.object.isRequired,
    };

    createQuery(settings: ISettings, reportSettings: IReportSettings) {
        let { includeTags, excludeTags } = settings;

        const query = new RemoteQuery({
            customerId: reportSettings.customerId,
            subtype: 2,
        });

        const queryWrapper = {
            query: query.get(),
            agent: false,
            container: true,
        };

        query.includeTags(includeTags);
        query.excludeTags(excludeTags);

        return queryWrapper;
    }

    fetchBaseData(props: IProps) {
        const { listSystems, widgetId, settings, reportSettings } = props;

        if (reportSettings.customerId) {
            listSystems(
                widgetId,
                this.createQuery(settings, reportSettings)
            );
        }
    }

    componentDidMount() {
        this.fetchBaseData(this.props);
    }

    componentWillReceiveProps(nextProps) {
        const { settings, reportSettings } = this.props;
        if (settings !== nextProps.settings || reportSettings !== nextProps.reportSettings) {
            this.fetchBaseData(nextProps);
        }
    }

    renderLoading() {
        return (
            <LoadingCircle size="xxl" name={this.props.widgetId} infinite />
        );
    }

    render() {
        const { widgetId, widgetData, settings, reportSettings } = this.props;
        const { systems } = widgetData;
        const data = [systems];

        if (RemoteDataUtil.isLoading(data)) {
            return this.renderLoading();
        }

        if (RemoteDataUtil.isError(data)) {
            return renderErrorObject(widgetId, data);
        }

        return (
            <Widget systems={systems ? systems.data : []} settings={settings} reportSettings={reportSettings}/>
        );
    }
}

const mapStateToProps = (state: IState, props: IProps) => ({
    widgetData: state.widgetData[props.widgetId] || { systems: null },
    reportSettings: state.reportSettings,
    settings: (state.reportTemplate.byId[props.widgetId] || {}).settings,
});

export default connect(
    mapStateToProps,
    {
        listSystems: PmAction.System.listSystems,
    }
)(WidgetContainer);


// WEBPACK FOOTER //
// ./src/components/widget/pm/listSystems/WidgetContainer.tsx